import * as React from 'react';

// --- Stepper (pure Tailwind, hex colors)
// Props: total (number of steps), current (0..total; 0 fills none)
export function Stepper({
  total,
  current,
  className,
}: {
  total: number;
  current: number;
  className?: string;
}) {
  const safeTotal = Math.max(1, Math.floor(total || 1));
  // Allow 0 so none of the bubbles/lines are filled
  const safeCurrent = Math.min(
    Math.max(0, Math.floor(current ?? 0)),
    safeTotal,
  );
  const steps = Array.from({ length: safeTotal }, (_, i) => i + 1);

  return (
    <nav
      aria-label={`Progress: step ${safeCurrent} of ${safeTotal}`}
      className={`w-full ${className ?? ''}`}
    >
      <div className="flex items-center w-full">
        {steps.map((i) => (
          <React.Fragment key={i}>
            {/* Circle */}
            <div
              className={
                `flex h-[30px] w-[30px] items-center justify-center rounded-full border-2 text-md font-semibold ` +
                (i <= safeCurrent
                  ? 'bg-[#2563EB] border-[#2563EB] text-[#FFFFFF]'
                  : 'bg-[#D1D5DB] border-[#D1D5DB] text-[#FFFFFF]')
              }
              aria-current={
                i === safeCurrent && safeCurrent > 0 ? 'step' : undefined
              }
              aria-label={`Step ${i}${
                i === safeCurrent && safeCurrent > 0
                  ? ', current'
                  : i < safeCurrent
                    ? ', completed'
                    : ', upcoming'
              }`}
              title={`Step ${i}`}
            >
              {i}
            </div>

            {/* Connector */}
            {i < safeTotal && (
              <div
                className={`mx-2 h-[1px] flex-1 ${i < safeCurrent ? 'bg-[#2563EB]' : 'bg-[#D1D5DB]'}`}
                aria-hidden="true"
              />
            )}
          </React.Fragment>
        ))}
      </div>
    </nav>
  );
}
